import template from './index.jst';
import { CoreFooterView } from '../../../../core/views';
import './index.styl'

class FooterView extends CoreFooterView {
	get template() {
		return template;
	}
}

export default FooterView;